import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let cache = null;
const listeners = new Set();

export const loadSite = () => api.get("/meta/site").then(({ data }) => { cache = data; listeners.forEach((l) => l(data)); return data; });

export const useSite = () => {
    const [site, setSite] = useState(cache || {});
    useEffect(() => {
        listeners.add(setSite);
        if (!cache) loadSite().catch(() => {});
        return () => listeners.delete(setSite);
    }, []);
    return site;
};

export const PrivacyLink = ({ children, className = "underline", testId }) => {
    const { privacy_policy_url: url } = useSite();
    return (
        <a href={url || "/informativa-privacy"} target="_blank" rel="noopener noreferrer" className={className} data-testid={testId}>{children}</a>
    );
};
